import type { User } from '../user.interface'
import { decodeJwtPayload } from '../utils/decode-jwt-payload'

export async function userToObjectFromToken(token: string): Promise<User | null> {
  const decodedToken = decodeJwtPayload(token)
  return {
    id: decodedToken?.sub ?? '',
    emailHash: decodedToken?.email_hash,
    graftcodeUid: decodedToken?.graftcode_uid,
  }
}
